<template>
  <div class="mypage-order-page-container">
    <h1 class="mypage-order-page-title">마이페이지</h1>
    <MyPageNavigatorVue />
    <MyPageOrderVue />
  </div>
</template>

<script>
import MyPageNavigatorVue from '@/components/MyPage/MyPageNavigator.vue'
import MyPageOrderVue from '@/components/MyPage/MyPageOrder/MyPageOrder.vue'

export default {
  name: 'MyPageMyOrder',
  components: {
    MyPageOrderVue,
    MyPageNavigatorVue
  },
  mounted() {
    window.scrollTo(0,0)
  }
}
</script>

<style>
.mypage-order-page-container {
  display: flex;
  flex-direction: column;
  max-width: 720px;
  margin: 0 auto;
  padding: 40px 24px 60px;
  box-sizing: border-box;
  font-family: var(--font-sans);
}
.mypage-order-page-title {
  margin: 0 0 24px;
  font-size: 24px;
  font-weight: var(--font-weight-bold);
  color: var(--text-heading);
  text-align: left;
}
</style>